import { QRCodeSVG } from 'qrcode.react';
import React from 'react';

import Skeleton from 'components/Skeleton';

import * as S from './styled';

export const QRCode = ({ deepLinkUrl, isLoading }: { deepLinkUrl: string; isLoading: boolean }) => (
    <S.ScanQrCodeWrapper data-testid="qr-code-wrapper">
        <S.QRWrapper>
            {isLoading ? <Skeleton borderRadius={8} width={132} height={132} /> : <QRCodeSVG value={deepLinkUrl} />}
        </S.QRWrapper>
    </S.ScanQrCodeWrapper>
);
